import { getSessionVar } from '../lib/helpers';

const getApplianceUrl = () => {
    return getSessionVar('repo_urls')?.appliances || '';
};

// Cloud size configuration for different cloud providers
export const CLOUD_SIZE_CONFIG = {
    AWS: [
        't2.nano',
        't2.micro',
        't2.small',
        't2.medium',
        't2.large',
        't3.nano',
        't3.micro',
        't3.small',
        't3.medium',
        't3.large',
        't3.xlarge',
        't3.2xlarge',
        't3a.nano',
        't3a.micro',
        't3a.small',
        't3a.medium',
        't3a.large',
        't3a.xlarge',
        't3a.2xlarge',
        'm3.medium',
        'm3.large',
        'm3.xlarge',
        'm3.2xlarge',
        'm4.large',
        'm4.xlarge',
        'm4.2xlarge',
        'm4.4xlarge',
        'm4.10xlarge',
        'm5.large',
        'm5.xlarge',
        'm5.2xlarge',
        'm5.4xlarge',
        'm5.12xlarge',
        'm5.24xlarge',
        'c3.large',
        'c3.xlarge',
        'c3.2xlarge',
        'c3.4xlarge',
        'c3.8xlarge',
        'c4.large',
        'c4.xlarge',
        'c4.2xlarge',
        'c4.4xlarge',
        'c4.8xlarge',
        'c5.large',
        'c5.xlarge',
        'c5.2xlarge',
        'c5.4xlarge',
        'c5.9xlarge',
        'c5.18xlarge',
        'g2.2xlarge',
        'g2.8xlarge',
        'r3.large',
        'r3.xlarge',
        'r3.2xlarge',
        'r3.4xlarge',
        'r3.8xlarge',
        'r4.large',
        'r4.xlarge',
        'r4.2xlarge',
        'r4.4xlarge',
        'r4.8xlarge',
        'r5.large',
        'r5.xlarge',
        'r5.2xlarge',
        'r5.4xlarge',
        'r5.12xlarge',
        'r5.24xlarge',
        'r5.metal',
        'r5d.large',
        'r5d.xlarge',
        'r5d.2xlarge',
        'r5d.4xlarge',
        'r5d.12xlarge',
        'r5d.24xlarge',
        'r5d.metal',
        'd2.xlarge',
        'd2.2xlarge',
        'd2.4xlarge',
        'd2.8xlarge',
        'i2.xlarge',
        'i2.2xlarge',
        'i2.4xlarge',
        'i2.8xlarge',
        'hs1.8xlarge',
        't1.micro',
        'm1.small',
        'm1.medium',
        'm1.large',
        'm1.xlarge',
        'm2.xlarge',
        'm2.2xlarge',
        'm2.4xlarge',
        'c1.medium',
        'c1.xlarge',
        'cc1.4xlarge',
        'cc2.8xlarge',
        'cg1.4xlarge',
        'cr1.8xlarge',
        'hi1.4xlarge',
    ],
    Azure: [
        'Standard_B1ls',
        'Standard_B1ms',
        'Standard_B2ms',
        'Standard_B2s',
        'Standard_B4ms',
        'Standard_B8ms',
        'Standard_B12ms',
        'Standard_B16ms',
        'Standard_B20ms',
        'Standard_D1',
        'Standard_D11',
        'Standard_D12',
        'Standard_D13',
        'Standard_D14',
        'Standard_D1_v2',
        'Standard_D2_v2',
        'Standard_D3_v2',
        'Standard_D4_v2',
        'Standard_D5_v2',
        'Standard_D11_v2',
        'Standard_D12_v2',
        'Standard_D13_v2',
        'Standard_D14_v2',
        'Standard_D2',
        'Standard_D2_v2_Promo',
        'Standard_D2_v4',
        'Standard_D2d_v4',
        'Standard_D2ds_v4',
        'Standard_D2s_v4',
        'Standard_D3',
        'Standard_D32_v4',
        'Standard_D32d_v4',
        'Standard_D32ds_v4',
        'Standard_D32s_v4',
        'Standard_D4',
        'Standard_D4_v4',
        'Standard_D48_v4',
        'Standard_D48d_v4',
        'Standard_D48ds_v4',
        'Standard_D48s_v4',
        'Standard_D4d_v4',
        'Standard_D4ds_v4',
        'Standard_D4s_v4',
        'Standard_D3_v2_Promo',
        'Standard_D4_v2_Promo',
        'Standard_D5_v2_Promo',
        'Standard_D8_v4',
        'Standard_D8d_v4',
        'Standard_D8ds_v4',
        'Standard_D8s_v4',
        'Standard_D11_v2_Promo',
        'Standard_D12_v2_Promo',
        'Standard_D13_v2_Promo',
        'Standard_D14_v2_Promo',
        'Standard_F1',
        'Standard_F2',
        'Standard_F4',
        'Standard_F8',
        'Standard_F16',
    ],
    GCP: [
        'a2-highgpu-1g',
        'a2-highgpu-2g',
        'a2-highgpu-4g',
        'a2-highgpu-8g',
        'a2-megagpu-16g',
        'c2-standard-16',
        'c2-standard-30',
        'c2-standard-4',
        'c2-standard-60',
        'c2-standard-8',
        'e2-highcpu-16',
        'e2-highcpu-2',
        'e2-highcpu-32',
        'e2-highcpu-4',
        'e2-highcpu-8',
        'e2-highmem-16',
        'e2-highmem-2',
        'e2-highmem-4',
        'e2-highmem-8',
        'e2-medium',
        'e2-micro',
        'e2-small',
        'e2-standard-16',
        'e2-standard-2',
        'e2-standard-32',
        'e2-standard-4',
        'e2-standard-8',
        'f1-micro',
        'g1-small',
        'n1-standard-1',
        'n1-standard-16',
        'n1-standard-2',
        'n1-standard-32',
        'n1-standard-4',
        'n1-standard-64',
        'n1-standard-8',
        'n1-standard-96',
    ],
};

export const CONFIG = {
    CUTOFF_VERSION_FOR_UPGRADE_AVAIL: '0.73',
    CUTOFF_VERSION_FOR_PYTHON2: '0.119',
    CUTOFF_VERSION_FOR_NETWORK_TROUBLESHOOTING: '0.97.3589',
    CUTOFF_VERSION_CA: '0.75',
    CUTOFF_VERSION_CA_DATAONLY: '0.79',
    //RM-9816 -- Block data only Windows differential migration for CAs version < 0.80
    WINDOWS_CUTOFF_VERSION_CA_DATAONLY: '0.80',

    ADD_SERVER_LINK: 'https://docs.rivermeadow.com/add-source',
    SUPPORTED_OS_LINK: 'https://docs.rivermeadow.com/support-matrix',

    AWS_MIGRATION_LINK: 'https://docs.rivermeadow.com/aws-migrations',
    AZURE_MIGRATION_LINK: 'https://docs.rivermeadow.com/azure-migration',
    VSPHERE_MIGRATION_LINK: 'https://docs.rivermeadow.com/vsphere-standalone-migration',
    OPENSTACK_MIGRATION_LINK: 'https://docs.rivermeadow.com/openstack-migration',
    OPENSHIFT_MIGRATION_LINK: 'https://docs.rivermeadow.com/openshift-migration',
    GCP_MIGRATION_LINK: 'https://docs.rivermeadow.com/gcp-migration',

    AWS_ROLE_DOCS_LINK: 'https://docs.rivermeadow.com/aws-create-role',
    AWS_ROLE_CLOUDFORMATION_DOCS_LINK: 'https://docs.rivermeadow.com/aws-create-role$CloudFormation',
    AWS_ROLE_MANUAL_DOCS_LINK: 'https://docs.rivermeadow.com/aws-create-role$Manual',
    GCP_MANUAL_SETUP_ACCOUNT_LINK: 'https://docs.rivermeadow.com/gcp-setup-customer-service-account',
    GCP_MANUAL_RIVERMEADOW_ACCESS_LINK: 'https://docs.rivermeadow.com/gcp-allow-rm-service-account',

    AWS_DOCS_LINK: 'https://docs.rivermeadow.com/aws-requirements',
    AZURE_DOCS_LINK: 'https://docs.rivermeadow.com/azure-requirements',
    VSPHERE_DOCS_LINK: 'https://docs.rivermeadow.com/vsphere-requirements',
    OPENSTACK_DOCS_LINK: 'https://docs.rivermeadow.com/openstack-requirements',
    OPENSHIFT_DOCS_LINK: 'https://docs.rivermeadow.com/openshift-requirements',
    GCP_DOCS_LINK: 'https://docs.rivermeadow.com/gcp-requirements',
    NC2_DOCS_LINK: 'https://docs.rivermeadow.com/nc2-requirements',
    HPE_VME_DOCS_LINK: 'https://docs.rivermeadow.com/hpe-vme-requirements',
    HYPERV_DOCS_LINK: 'https://docs.rivermeadow.com/hyperv-requirements',

    AWS_APPLIANCE_DOCS: 'https://docs.rivermeadow.com/aws-launch-migration-appliance',
    AZURE_APPLIANCE_DOCS: 'https://docs.rivermeadow.com/azure-launch-migration-appliance',
    VSPHERE_APPLIANCE_DOCS: 'https://docs.rivermeadow.com/vsphere-standalone-launch-migration-appliance',
    OPENSTACK_APPLIANCE_DOCS: 'https://docs.rivermeadow.com/openstack-launch-cloud-appliance',
    OPENSHIFT_APPLIANCE_DOCS: 'https://docs.rivermeadow.com/openshift-launch-cloud-appliance',
    NC2_APPLIANCE_DOCS: 'https://docs.rivermeadow.com/nutanix-standalone-launch-mig',
    HPE_VME_APPLIANCE_DOCS: 'https://docs.rivermeadow.com/hpe-vme-standalone-launch-mig',
    HYPERV_APPLIANCE_DOCS: 'https://docs.rivermeadow.com/microsoft-hyper-v-launch-cloud-appliance',
    AZURE_APP_REGISTRATION_DOCS: 'https://docs.rivermeadow.com/azure-app-registration',
    GCP_APPLIANCE_DOCS: 'https://docs.rivermeadow.com/gcp-launch-migration-appliance',
    VSPHERE_RM_APPLIANCE_URL: function (ver) {
        return getApplianceUrl() + '/rms-ma-vsphere-' + ver + '.zip';
    },
    VSPHERE_RM_DR_BACKUP_APPLIANCE_URL: function (ver) {
        return getApplianceUrl() + '/rms-backup-vsphere-' + ver + '.zip';
    },
    VSPHERE_RM_DR_DATASTORE_APPLIANCE_URL: function (ver) {
        return getApplianceUrl() + '/rms-dr-vsphere-datastore-' + ver + '.zip';
    },
    VSPHERE_RM_DR_SITES_APPLIANCE_URL: function (ver) {
        return getApplianceUrl() + '/rms-dr-vsphere-primary-dr-sites-' + ver + '.zip';
    },
    OPENSTACK_APPLIANCE_URL: function (ver) {
        return getApplianceUrl() + '/rms-ma-openstack-' + ver + '.zip';
    },
    OPENSHIFT_APPLIANCE_URL: function (ver) {
        return getApplianceUrl() + '/rms-ma-openshift-' + ver + '.zip';
    },
    NC2_APPLIANCE_URL: function (ver) {
        return getApplianceUrl() + '/rms-ma-nc2-' + ver + '.zip';
    },
    HPE_VME_APPLIANCE_URL: function (ver) {
        return getApplianceUrl() + '/rms-ma-hpe-vme-' + ver + '.zip';
    },
    HYPERV_APPLIANCE_URL: function (ver) {
        return getApplianceUrl() + '/rms-ma-hyperv-' + ver + '.zip';
    },
    AWS_APPLIANCE_SG: ['RM-CA'],
    AWS_TARGET_WORKER_SG: ['RM-TW'],
    OPENSTACK_TARGET_WORKER_SG: ['RM-Migration-TargetWorker'],
    OPENSHIFT_TARGET_WORKER_SG: ['RM-Migration-TargetWorker'],
    PASSWORD_MIN_LENGTH: 8,
    SESSION_TIMEOUT_WARNING_MILLISECONDS: 600000, //10 minutes
    FE_SESSION_TOKEN_EXPIRATION_MILLISECONDS: 1200000, //20 minutes
    GRID_RUNNING_REFRESH_INTERVAL_MILLISECONDS: 10000, // 10 seconds
    GRID_RUNNING_REFRESH_RANDOM_DELAY: 10000, // 10 seconds
    GRID_PENDING_REFRESH_INTERVAL_MILLISECONDS: 20000, //20 seconds
    GRID_PENDING_REFRESH_RANDOM_DELAY: 10000, // 10 seconds
    GRID_APPLIANCE_DEPLOY_REFRESH_DELAY: 15000,
    //FOR RECOVERABLE ERRORS WE PUT A LONG REFRESH
    GRID_RECOVERABLE_REFRESH_INTERVAL_MILLISECONDS: 30000,
    GRID_RECOVERABLE_REFRESH_INTERVAL_DELAY: 15000,
    // VM source inventory
    SOURCE_INVENTORY_POLL_INTERVAL_MILLISECONDS: 5000, // 5 seconds
    SOURCE_INVENTORY_POLL_RANDOM_DELAY: 10000, // 10 seconds
    // Migration preflight
    MIGRATION_PREFLIGTH_POLL_INTERVAL_MILLISECONDS: 4000, // 4 seconds
    MIGRATION_PREFLIGTH_POLL_RANDOM_DELAY: 2000, // 2 seconds
    // 1 hour
    CLOUD_APPLIANCE_ATTRIBUTE_COLLECTION_TIMEOUT_MILLISECONDS: 3600000,
    DEFAULT_DATA_TRANSFER_PORT: 5995,
    LINUX_BBT_MAX_VFAT_SIZE_GB: 1,
    REQUIRED_SOURCE_PACKAGES_FOR_DM: ['rsync'],
    EXCLUDED_LINUX_FS: {
        squashfs: true,
    },
    SUPPORTED_LINUX_BBT_FS: ['ext2', 'ext3', 'ext4', 'xfs', 'vfat'],
    SUPPORTED_LINUX_BBT_DISK_NATURE: ['disk'],
};
